import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { OperationListItemModel } from '../../models/operation/operation-list-item.model';
import { Observable } from 'rxjs';
import { OperationListParams } from '../../models/client-models';

const OPERATION_ENDPOINT = 'operation';

@Injectable({
  providedIn: 'root',
})
export class OperationBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get operation list with paging and filters.
   *
   * @param operationParams filter, paging, personID and OrderID.
   */
  public getOperationList(operationParams: OperationListParams) {
    return this.http.post<OperationListItemModel[]>(
      AppConfig.settings.backend.url + OPERATION_ENDPOINT,
      operationParams
    );
  }

  /**
   * Get operation by id.
   *
   * @param aksPlanID operation id.
   */
  public getOperationByID(
    aksPlanID: number
  ): Observable<OperationListItemModel> {
    return this.http.get<OperationListItemModel>(
      AppConfig.settings.backend.url + OPERATION_ENDPOINT + '?id=aksPlanID'
    );
  }
}
